<template>
    <div
            v-loading="loading"
            class="row flex-column"
    >
        <div
                class=""
                v-if="projects.hasOwnProperty('data') && projects.data.length > 0"
        >
            <div class="mt-1">
                <div class="block block-rounded block-mode-loading-refresh">
                    <div class="block-content block-content-full block-content-sm bg-body-dark">
                        <input
                                @keyup="getProjects()"
                                v-model="query"
                                type="text"
                                class="form-control form-control-alt"
                                placeholder="Search Projects.."
                        />
                    </div>
                    <div class="block-content-full">
                        <table class="table table-striped table-hover table-borderless table-vcenter font-size-sm">
                            <tbody>
                            <tr
                                    v-for="(project, key) in projects.data"
                                    :key="key"
                            >
                                <td class="text-center">
                                    <avatar
                                            :lighten="200"
                                            :customStyle="{'border-radius': '5px'}"
                                            :rounded="false"
                                            :username="project.name"
                                    />
                                </td>
                                <td>
                                    <a
                                            @click.prevent="goToProject(project.id)"
                                            href=""
                                            class="font-w700 font-size-base pb-1"
                                    >{{project.name}}</a>
                                    <div class="text-muted">{{project.description}}</div>
                                </td>
                                <td
                                        class="d-none d-md-table-cell align-content-center"
                                        style="min-width: 150px;"
                                >
                                    <a
                                            class="img-link m-1"
                                            href="javascript:void(0)"
                                            v-for="(member, index) in project.members"
                                            :key="index"
                                            :class="{'mr-1 ml-n3': index > 0}"
                                    >
                                        <el-tooltip
                                                :content="member.name"
                                                placement="top"
                                                v-if="index < 3"
                                        >
                                            <img
                                                    v-if="member.social_avatar.avatar !== null"
                                                    class="img-avatar img-avatar32"
                                                    :src="member.social_avatar.avatar"
                                                    alt=""
                                            >
                                            <v-avatar
                                                    :size="800"
                                                    default-img="identicon"
                                                    v-else
                                                    class="img-avatar img-avatar32"
                                                    :email="member.email"
                                            />
                                        </el-tooltip>
                                    </a>
                                    <strong
                                            v-if="project.members.length > 3"
                                            class="ml-3 font-w700 small"
                                    >+{{project.members.length
                                    - 3 }} More</strong>

                                </td>
                                <td class="d-sm-table-cell">
                                    <div class="small text-muted d-table-row mt-n2">Project Id</div>
                                    <div class="font-w700"> {{project.id}}</div>
                                </td>
                                <td class="text-center">
                                    <div class="dropdown">
                                        <button
                                                type="button"
                                                class="btn-block-option"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                        >
                                            <i class="si si-menu"/>
                                        </button>
                                        <div
                                                class="dropdown-menu dropdown-menu-right"
                                                x-placement="bottom-end"
                                        >
                                            <a
                                                    @click.prevent="goToProject(project.id)"
                                                    class="dropdown-item"
                                                    href="#"
                                            >
                                                <i class="far fa-fw fa-folder-open mr-1"/> View Project
                                            </a>
                                            <a
                                                    @click.prevent="inviteUser(project.id)"
                                                    class="dropdown-item"
                                                    href="#"
                                            >
                                                <i class="fa fa-fw fa-plus mr-1"/> Invite User
                                            </a>
                                            <router-link
                                                    :to="`/projects/${project.id}/edit`"
                                                    class="dropdown-item"
                                                    href="javascript:void(0)"
                                            >
                                                <i class="fa fa-fw fa-pencil-alt mr-1"/> Edit Project
                                            </router-link>
                                            <div
                                                    role="separator"
                                                    class="dropdown-divider"
                                            ></div>
                                            <a
                                                    class="dropdown-item text-danger"
                                                    @click="deleteProject(project.id)"
                                                    href="javascript:void(0)"
                                            >
                                                <i class="fa fa-fw fa-trash-alt"/> Delete Project
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <invite-user-to-project :project-id="invitedUserProjectId">

                    </invite-user-to-project>
                    <div class="block-content">
                        <div class="mr-4">
                            <pagination
                                    align="right"
                                    :data="projects"
                                    @pagination-change-page="getProjects"
                            ></pagination>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div
                class="row"
                v-else
        >
            <div class="content">
                <div class="text-center py-3">
                    <div class="py-3">
                        <i
                                class="material-icons"
                                style="font-size: 64px;"
                        >dvr</i>
                    </div>
                    <h1 class="h3 font-w700 mb-2">No projects found</h1>
                    <h2 class="h5 font-w400 text-muted">You don't have any projects yet. Create a new project to start
                        exploring our APIs</h2>
                    <a
                            v-if="user && user.projectCount < 2 || $hasRole('admin')"
                            class="btn btn-success my-2"
                            @click.prevent="createProject"
                            href=""
                    >
                        <i class="fa fa-fw fa-plus"></i><span class="d-none d-sm-inline ml-1"> New Project</span>
                    </a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {APP_CONFIG} from "../../config";
import Avatar from "vue-avatar";
import GravatarImg from "vue-gravatar";
import InviteUserToProject from "./InviteUserToProject";
import {axios} from '../../bootstrap';

export default {
    name: "Projects",
    components: {
        InviteUserToProject,
        Avatar,
        "v-avatar": GravatarImg
    },
    data() {
        return {
            query: "",
            currentPage: 1,
            invitedUserProjectId: ""
        };
    },
    computed: {
        ...mapGetters({
            loading: "getLoadingStatus",
            projects: "getProjects"
        })
    },
    methods: {
        createProject() {
            this.$router.push("/projects/create");
        },

        getProjects(page = 1) {
            this.currentPage = page;
            this.$store.dispatch("getProjects", {
                page,
                query: this.query
            });
        },
        inviteUser(projectId) {
            this.invitedUserProjectId = projectId;
            this.$store.commit("setInvitedUserDialogVisible", true);
        },

        goToProject(projectId) {
            location.assign(`projects/${projectId}/overview`)
        },
        deleteProject(project) {
            this.$confirm(
                    "This will permanently delete the project. Continue?",
                    "Warning",
                    {
                        confirmButtonText: "Delete",
                        cancelButtonText: "Cancel",
                        type: "warning"
                    }
            ).then(() => {
                axios.delete(APP_CONFIG.URL + "projects/" + project).then(() => {
                    this.$message({
                        type: "success",
                        message: "The project was Deleted successfully"
                    });
                    this.getProjects();
                });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "Delete canceled"
                });
            });
        }
    }
};
</script>

<style scoped>
.dropdown-menu.show {
    z-index: 1600;
}
</style>
